<div class="no-results-state">
  <div class="no-results-icon-circle">
    <app-icon alt="" [ariaHidden]="true" src="search.svg" [height]="30" [width]="30" className="no-results-icon" />
  </div>
  <p class="no-results-title">Keine Ergebnisse für „{{ query().trim() }}"</p>
  <p class="no-results-body">
    Überprüfe die Schreibweise oder versuche einen anderen Begriff — die Suche umfasst News, Produkte und
    Beratungsmappen.
  </p>
</div>
